export const messages = {
  UPLOADED_SUCCESSFULLY:
    "Video or Photo uploaded successfully. You'll receive an email once it's live!",
  UPDATED_SUCCESSFULLY: 'Video or Photo updated successfully',
};
